import { Link, useLocation } from 'react-router-dom';

const LINKS = [
  { to: '/',             label: 'HOME'        },
  { to: '/photography',  label: 'PHOTOGRAPHY' },
  { to: '/videography',  label: 'VIDEOGRAPHY' },
  { to: '/store',        label: 'STORE'        },
];

export default function TopNav() {
  const { pathname } = useLocation();
  return (
    <header className="top-nav-bar" style={{
      position: 'fixed', top: 0, left: 0, right: 0,
      height: 64,
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '0 48px',
      background: 'linear-gradient(180deg, rgba(0,0,0,0.92) 0%, transparent 100%)',
      zIndex: 100,
    }}>
      <Link to="/" style={{
        fontFamily: 'var(--font-display)', fontWeight: 900, fontSize: 14,
        textTransform: 'uppercase', letterSpacing: '0.05em',
        color: 'var(--bone)', textDecoration: 'none',
      }}>
        DREW HALLÉ<span style={{ color: 'var(--red)' }}>.</span>
      </Link>
      <nav className="top-nav-links" style={{ display: 'flex', gap: 32 }}>
        {LINKS.map(({ to, label }) => (
          <Link key={to} to={to} style={{
            fontFamily: 'var(--font-mono)', fontSize: 10, letterSpacing: '0.2em',
            textTransform: 'uppercase',
            color: pathname === to ? 'var(--bone)' : 'var(--bone-50)',
            textDecoration: 'none',
            transition: 'color 200ms',
          }}>
            {label}
          </Link>
        ))}
      </nav>
    </header>
  );
}
